import React from 'react';
import { Box, Text, Pressable, Avatar, HStack, VStack, useTheme } from 'native-base';
import Highlighter from 'react-highlight-words';
import { useCategoriesState } from '../../context/categories';
import { useEnvState } from '../../context/env';
import { displayTime, getCategoryNames } from '../utils/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { AVATAR_SIZE } from '../Constants';
const ResultItem = _ref => {
  let {
    item,
    navigation,
    setShowSearchModal,
    term
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const envState = useEnvState();
  const categoriesState = useCategoriesState();
  const {
    forumCategories: categories,
    rootProductCategory
  } = categoriesState;
  const keywords = term === null || term === void 0 ? void 0 : term.split(' ');
  const categoryNames = getCategoryNames(item.category_id, rootProductCategory, categories);
  const handleOnPress = () => {
    setShowSearchModal && setShowSearchModal(false);
    navigation.navigate('SingleTopic', {
      topicId: item.topic_id,
      replyId: item.id,
      featuredReply: item,
      normalizeUrl: false
    });
  };
  const avatarTemplate = item.avatar_template.replace(/\{size\}/, AVATAR_SIZE);
  return /*#__PURE__*/React.createElement(Pressable, {
    onPress: handleOnPress,
    borderRadius: 20
  }, /*#__PURE__*/React.createElement(Box, {
    bg: colors.searchResultItem.box.bg,
    w: "100%",
    p: "4",
    my: "1"
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: 2,
    py: "2",
    w: "100%"
  }, /*#__PURE__*/React.createElement(Avatar, {
    source: {
      uri: `${envState.base_url}${avatarTemplate}`
    },
    size: "sm",
    ml: "2"
  }, "Replier Profile Image"), /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "semibold"
  }, item.name), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Text, {
    color: colors.searchResultItem.created
  }, displayTime(item.created_at), " ago in"), ' ', categoryNames.length && /*#__PURE__*/React.createElement(Text, {
    color: colors.searchResultItem.categoryName
  }, categoryNames)))), /*#__PURE__*/React.createElement(Highlighter, {
    highlightStyle: {
      fontWeight: 'bold',
      backgroundColor: 'transparent'
    },
    searchWords: keywords,
    textToHighlight: item.blurb,
    style: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      padding: 5
    }
  }), /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: "center",
    pl: "1"
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.searchResultItem.link
  }, "Go to post"), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronRight,
    color: colors.searchResultItem.link
  }))));
};
export default ResultItem;
//# sourceMappingURL=ResultItem.js.map